<template>
  <div @click="current=-1">
    <div class="header-wrap">
      <div class="header container rm-l-p rm-r-p">
        <router-link to="/">
        <div class="pull-left header-left">
          <a class="logo">
            <img src="../assets/img/logo.png" alt="一路牛" height="38">
          </a>
        </div>
        </router-link>
        <user-list/>
      </div>
    </div>
    <div class="headline-bg">
      <div id="waves" class="waves"></div>
    </div>
    <div class="container rm-l-p rm-r-p" id="contents" v-loading="loading">
      <div id="main" class="main">
        <p class="close">
            <span v-show="show" @click="show=false" class="icon-ic-close" style="font-size: 16px;"><i class="ldms-font ldms-guanbi"></i>关闭</span>
        </p>
        <div class="dashboard-func " v-show="!show" >
          <div class="pull-left fill">
            <div class="app-fill">
              <span class="select" >所有应用</span>
            </div>
          </div>
          <ul class="ftBtn clearfix">
            <li class="pull-left ldms-font ldms-shijian" style="font-size: 24px;text-align: center;padding-left: 4px;"></li>
            <li class="pull-left"><a href="javascript:void(0)" target="_blank">全部列表</a></li>
          </ul>
        </div>
        <div class="form " :key="show" v-show="show">
          <ul class="card-form">
            <div class="tl" style="opacity: 0;">请输入应用名称</div>
            <li class="li-app-name">
              <div class="add-app-tips">
                <label for="app-name" id="app-name-tipserror" class="section-tipserror card-creat-section-tipserror" v-show="tip">
                  <span class=" icon ldms-font ldms-iconfontgantanhao3"></span>
                  <span class="text">{{errMsg}}</span>
                </label>
              </div>
              <input type="text" id="app-name" v-model="app.name" class="card-form-input" maxlength="20" placeholder="输入应用名称以创建" autofocus="true" autocomplete="off" data-com.agilebits.onepassword.user-edited="yes">
              <i class="line-b"></i>
            </li>
          </ul>
          <!--<label for="app-name" id="app-numlimit-tipserror" class="section-tipserror">-->
            <!--<span class="icon-06-2 icon ldms-font">&#xe607;</span>-->
            <!--<span class="text">单个帐户最多可以创建16个免费应用</span>-->
          <!--</label>-->
          <button class="card-create-btn" :disabled="isdisabled" @click="createApp">创&nbsp;建</button>
          <div id="create-app-loading" class="spinners cards-creat-spinner">
            <div class="bounce1"></div>
            <div class="bounce2"></div>
            <div class="bounce3"></div>
          </div>
        </div>
        <div class="cards cards-group " :key="!show" v-show="!show">
          <div id="cards-container">
            <div v-if="apps" v-loading="loadingCard == index ? true :false"  v-for="(item, index) in apps" :key="item.appId" class="card card-normal" :class="'cards-normal-bg'+(index+1)"  style="cursor: pointer" @click="intoApp(item.appId)">
              <div id="plan-info" class="cards-normal-bg">
                <div class="bg-left">
                  <h1 class="cards-normal-title fzlt">{{item.appName}}</h1>
                  <span class="user-url-address">一路牛配货提供服务</span>
                </div>
                <div class="bg-right" v-if="item.owner == userInfo.user.userName" @click.stop.prevent="showList($event,index)">
                  <i class="ldms-font ldms-diandian"  style="font-size: 18px;color: #cacaca;"></i>
                  <ul class="user-items-exp" :style="index == current ? 'display:block' : 'display:none'">
                    <s class="cor_s">
                      <i class="cor_i"></i>
                    </s>
                    <li class="mod" @click="updateApp(item.appId, item.appName, index)"><i class="icon-09 ldms-font ldms-pencil"></i>修改应用名称</li>
                    <li class="man" @click="management(item)"><i class="icon-10 ldms-font">&#xe7e6;</i>管理人员</li>
                    <li class="del" @click="deleteApp(item.appId)"><i class="icon-30 ldms-font ldms-changyonggoupiaorenshanchu"></i>删除应用</li>
                  </ul>
                </div>
              </div>
              <ul class="cards-normal-func clearfix">
                <li class="func-item"><a href="javascript:void(0)">所有人:{{item.owner}}</a></li>
                <el-popover
                  placement="right"
                  trigger="hover">
                  <p v-for="user in item.users" :key="user.userId">{{user.userName}}</p>
                  <li class="func-item" slot="reference" ><a href="javascript:void(0)">配货人数{{item.users.length}}人</a></li>
                </el-popover>
              </ul>
            </div>
            <div class="card create-card" @click="show=true">
              <div class="create-cardbtn"><i class="ldms-font ldms-jia"></i><span>创建应用</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="人员管理" :visible.sync="dialogVisible" width="30%" @open="closeWindow">
        <el-tabs type="card" :stretch="true">
          <el-tab-pane label="添加人员">
            <div style="margin-top: 20px">
              <el-form :model="addManagerForm" ref="validateF" size="medium" @submit.native.prevent>
              <el-form-item
                prop="phone"
                :rules="[
                        { required: true, message: '电话不能为空'},
                        {pattern: /^0?1[3|4|5|6|9|8|7][0-9]\d{8}$/, message: '电话格式不正确', trigger: ['blur', 'change']}
                      ]" >
                <el-input placeholder="请输入电话号码" v-model="addManagerForm.phone" autocomplete="off">
                  <template slot="append">
                    <el-button type="success" @click="sendInvite('validateF')" class="sendInvite">发送邀请</el-button>
                  </template>
                </el-input>
              </el-form-item>
            </el-form>
              <div class="add-developer-tips">
                被邀请的开发者不能移除应用，编辑或邀请/删除其他人员。
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="人员列表">
            <ul>
              <li class="developer-item-layer text-left" v-for="(item,index) in appUserList.users" :key="item.userId">
                <span class="manage-developer-avatar-layer">
                  <img :src="appUserList.prefix+item.head" class="manage-developer-avatar" width="24" height="24">
                </span>
                <span class="developer-item-layer-email">{{item.userName}}：{{item.phone}}</span>
                <span class="developer-item-layer-role" v-if="index === 0">所有者</span>
                <span class="developer-item-layer-role" v-if="index !== 0">使用者</span>
                <span class="man-app-developer-item-close el-icon-close" v-if="index != 0" @click="removeManage(item.userId, index)"></span>
              </li>
            </ul>
          </el-tab-pane>
        </el-tabs>
    </el-dialog>
  </div>
</template>
<script>
import userList from './layout/userList'

import { mapGetters } from 'vuex'
import { getAppList, createApp, deleteApp, updateApp, invitedUser, removeUser } from '@/api/app'

export default {
  data: function () {
    return {
      appUserList: '',
      addManagerForm: {
        phone: '',
        appId: ''
      },
      dialogVisible: false,
      apps: [],
      show: false,
      current: -1,
      loading: true,
      app: {
        name: ''
      },
      tip: false,
      isdisabled: false,
      errMsg: '名称不能为空',
      loadingCard: -1
    }
  },
  created () {
    this.getApp()
  },
  computed: {
    ...mapGetters({userInfo: 'user/userInfo'})
  },
  methods: {
    management (app) {
      this.appUserList = app
      this.dialogVisible = true
    },
    removeManage (userId, index) {
      let _this = this
      this.$confirm('是否确认移除该用户?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        removeUser(this.appUserList.appId, userId).then(response => {
          if (response) {
            _this.appUserList.users.splice(index, 1)
            _this.getApp()
          }
        })
      })
    },
    getApp () {
      let _this = this
      getAppList().then(data => {
        _this.apps = data.data.data
        _this.loading = false
      })
    },
    showList (event, index) {
      if (this.current === index) {
        this.current = -1
      } else {
        this.current = index
      }
    },
    intoApp (id) {
      this.$router.push('/app/' + id + '/appDashboard')
    },
    createApp () {
      let _this = this
      _this.isdisabled = true
      setTimeout(() => {
        _this.isdisabled = false
      }, 1000)
      if (this.app.name.trim().length > 0) {
        createApp(this.app).then(response => {
          _this.reset()
          _this.getApp()
        })
      } else {
        this.tip = true
      }
      //
    },
    closeWindow () {
      this.$nextTick(() => {
        this.$refs.validateF.clearValidate()
      })
      this.addManagerForm.phone = ''
    },
    sendInvite (formName) {
      let _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          invitedUser(this.appUserList.appId, this.addManagerForm.phone).then(response => {
            _this.addManagerForm.phone = ''
          })
        } else {
          return false
        }
      })
    },
    updateApp (appId, appName, index) {
      let _this = this
      this.$prompt('请输入名称', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: appName,
        inputPattern: /^.{2,20}$/,
        inputErrorMessage: '名称格式不正确'
      }).then(({ value }) => {
        _this.loadingCard = index
        _this.app.name = value
        updateApp(appId, _this.app).then(() => {
          _this.reset()
          _this.getApp()
        })
      })
    },
    deleteApp (appId) {
      let _this = this
      this.$confirm('此操作将永久删除该应用, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteApp(appId).then(() => {
          _this.reset()
          _this.getApp()
        })
      })
    },
    reset () {
      this.tip = false
      this.show = false
      this.app.name = ''
      setTimeout(() => {
        this.loadingCard = -1
      }, 1000)
    }
  },
  components: {
    userList
  }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '../assets/css/dashboard.css'
.add-app-tips
    .ldms-font
      &:before
        font-size 12px
.sendInvite
  color: #fff !important
  background-color: #409eff !important
  border-color: #409eff !important
  border 1px !important
  border-radius 0 !important
  &:hover
    background: #66b1ff !important
    border-color: #66b1ff !important
  &:active
    background: #3a8ee6 !important
    border-color: #3a8ee6 !important
</style>
